/**
 * TanStack Query hooks for `igaming-per-brand-responsible-gambling-filters`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPerBrandResponsibleGamblingFiltersQueryKeys,
	type CreateIgamingPerBrandResponsibleGamblingFiltersBody,
	type ListIgamingPerBrandResponsibleGamblingFiltersResponse,
	type IgamingPerBrandResponsibleGamblingFiltersRow,
} from "./api";

export function useIgamingPerBrandResponsibleGamblingFiltersList(): UseQueryResult<ListIgamingPerBrandResponsibleGamblingFiltersResponse, Error> {
	return useQuery({
		queryKey: igamingPerBrandResponsibleGamblingFiltersQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPerBrandResponsibleGamblingFiltersCreate(): UseMutationResult<IgamingPerBrandResponsibleGamblingFiltersRow, Error, CreateIgamingPerBrandResponsibleGamblingFiltersBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPerBrandResponsibleGamblingFiltersQueryKeys.all });
		},
	});
}

export function useIgamingPerBrandResponsibleGamblingFiltersDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPerBrandResponsibleGamblingFiltersQueryKeys.all });
		},
	});
}
